// WP-3.3 — Service projection (SVC-2 ratified). Architecture is FROZEN (ADR-0008 Option D, B-first,
// service-led; SAB audit: NO city pages). Pure & deterministic Service JSON-LD builder driven by the
// ratified catalogue (navigation/serviceCatalog). A Service references the Organization @id (provider)
// and inherits the SAB areaServed (single source — ADR-0009 P1; no per-service geo). Fail-closed:
// an incomplete descriptor projects nothing (anti-thin). Wedding Chauffeur is absent from the
// catalogue, so it can never be projected.
//
// NOTE: imports only seoData + sabProfile (NOT jsonld) to avoid an import cycle — ORG_ID is recomputed
// here from the same SEO_SITE_URL and asserted equal to jsonld's ORG_ID by the test suite.

import { SEO_SITE_URL } from './seoData';
import { AREA_SERVED } from './sabProfile';
import { SERVICE_CATALOG } from '../navigation/serviceCatalog';

export { SERVICE_CATALOG };

// Same value as jsonld.ORG_ID (stable fragment; Entity ID ≠ URL — ADR-0008 §7A / ADR-0009 P4).
const ORG_ID = `${SEO_SITE_URL}/#organization`;

// Pure, fail-closed Service builder. Returns null unless the descriptor is content-complete (anti-thin).
export function buildService(descriptor) {
  if (!descriptor || !descriptor.slug || !descriptor.name) return null;
  const node = {
    '@type': 'Service',
    '@id': `${SEO_SITE_URL}/#service/${descriptor.slug}`, // Entity ID ≠ URL (stable fragment)
    // Wave 2 — bind the Service entity to its canonical page (Entity ID ≠ URL — ADR-0008 §7A):
    // @id is the stable identifier; url is the page that describes the service. Same canonical as
    // seoData (single source for URLs); no new data.
    url: `${SEO_SITE_URL}/services/${descriptor.slug}`,
    name: descriptor.name,
    serviceType: descriptor.name,
    provider: { '@id': ORG_ID },
    // SAB: a service inherits the Organization's areaServed (single source; no per-service geo).
    areaServed: AREA_SERVED.map((p) => ({ '@type': p.type, name: p.name })),
  };
  if (descriptor.description) node.description = descriptor.description;
  return node;
}

// Projects the full ratified catalogue (fail-closed: incomplete entries dropped).
export function buildServiceCatalog() {
  return SERVICE_CATALOG.map(buildService).filter(Boolean);
}
